import { useMemo } from 'react';
import useAuth from '@/data/hook/useAuth';
import Klass from '@/models/Klass';
import ScheduledLesson from '@/models/ScheduledLesson';
import ScheduledLessonReportPermission from '@/utils/permissions/ScheduledLessonReportPermission';
import StudentReportPermission from '@/utils/permissions/StudentReportPermission';
import ScheduledLessonReport from '@/models/ScheduledLessonReport';
import Enrollment from '@/models/Enrollment';

type UseScheduledLessonReportProps = {
  scheduledLesson: ScheduledLesson;
  klass: Klass;
  report?: ScheduledLessonReport | undefined;
  enrollment?: Enrollment;
};

export default function useStudentReportRowPermissions({
  scheduledLesson,
  klass,
  report,
  enrollment,
}: UseScheduledLessonReportProps) {
  const { user } = useAuth();

  const permitions = useMemo(() => {
    const permission = new ScheduledLessonReportPermission({
      user,
      model: scheduledLesson,
      klass,
    });

    const studentPermissions = new StudentReportPermission({
      user,
      model: report,
      klass,
      enrollment,
      scheduledLesson,
    });

    return {
      hasPresencePermission: permission.canToggleHasDone(),
      hasReportPermission: permission.canManage(),
      isReportEditAllowed: studentPermissions?.canEditStudentReport(),
      canEditReportPanel: studentPermissions.canEditReportPanel(),
      canFinishReport: permission.hasRequiredFieldsToFinish(),
    };
  }, [user, scheduledLesson, klass, report, enrollment]);

  return {
    permitions,
  };
}
